import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from './api_slice';
import rootReducer from './reducers';
import draftSummaryOfChanges from './slice/draft_summary_of_changes';
import experience from './slice/experience';
import giftCard from './slice/gift_card';
import user from './slice/user';

const reducers = {
  ...rootReducer,
  experience,
  user,
  giftCard,
  draftSummaryOfChanges,
};
const store = configureStore({
  reducer: {
    ...reducers,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

window.ecom.redux_store = store;

export default store;

export const getMockStore = (preloadedState) =>
  configureStore({
    reducer: {
      ...reducers,
      [apiSlice.reducerPath]: apiSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(apiSlice.middleware),
    preloadedState,
  });
